module.exports = __webpack_public_path__ + "static/media/Nguyen_Trung_Thanh.fb97a28b.jpg";